// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sbc-wrapper {
  max-width: 960px;
  margin: 0 auto;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  color: #2b2b2b;
}

.sbc-header h2 {
  margin: 0 0 4px;
  font-size: 22px;
  font-weight: 700;
}

.sbc-subtitle {
  margin: 0 0 20px;
  color: #6b7280;
  font-size: 14px;
}

/* Employee info strip */
.sbc-employee-grid {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 6px;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.sbc-employee-grid label {
  margin: 0;
  color: #000;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.employee-value {
  margin: 0;
  padding: 0;
  color: #0d6efd;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sbc-employee-grid input:focus {
  outline: none;
  border-color: #6366f1;
  background: #fff;
}

/* Mode toggle */
.sbc-mode-toggle {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.sbc-mode-toggle label {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #d8dce1;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  transition: all 0.15s ease;
}

.sbc-mode-toggle label.active {
  border-color: #6366f1;
  background: #eef0ff;
  color: #4338ca;
}

.sbc-mode-toggle input[type="radio"] {
  accent-color: #6366f1;
}

/* Primary input */
.sbc-primary-input {
  margin-bottom: 20px;
}

.sbc-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #374151;
}

.sbc-field input {
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border: 1px solid #c7cbd1;
  border-radius: 8px;
}

.sbc-field input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

/* Table */
.sbc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-bottom: 16px;
  border: 1px solid #d8dce1;
}

.sbc-table th {
  text-align: left;
  background: #f3f4f6;
  padding: 10px 12px;
  font-weight: 600;
  border-bottom: 1px solid #d8dce1;
}

.sbc-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #eceef1;
  vertical-align: middle;
}

.sbc-table td:nth-child(2),
.sbc-table td:nth-child(3) {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.sbc-table tbody tr:hover {
  background: #fafbff;
}

.sbc-table input[type="number"] {
  width: 90px;
  padding: 5px 8px;
  text-align: right;
  border: 1px solid #c7cbd1;
  border-radius: 5px;
  font-size: 13px;
}

.sbc-table input[type="number"]:focus {
  outline: none;
  border-color: #6366f1;
}

.sbc-section td {
  background: #eef0ff;
  color: #4338ca;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding-top: 10px;
  padding-bottom: 10px;
}

.sbc-subtotal td {
  background: #f3f4f6;
  font-weight: 700;
  border-top: 1px solid #d8dce1;
  border-bottom: 1px solid #d8dce1;
}

.sbc-total td {
  background: #111827;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
}

.sbc-warning-row td {
  background: #fff4f4;
}

.sbc-warning-text {
  color: #b42318;
  background: #fff4f4;
  border: 1px solid #fecaca;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
}

/* Assumptions panel */
.sbc-toggle-assumptions {
  background: none;
  border: none;
  color: #4338ca;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-bottom: 12px;
}

.sbc-toggle-assumptions:hover {
  text-decoration: underline;
}

.sbc-assumptions-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.sbc-assumption-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sbc-assumption-row label {
  font-size: 12px;
  color: #6b7280;
}

.sbc-assumption-row input {
  padding: 6px 8px;
  border: 1px solid #c7cbd1;
  border-radius: 6px;
  font-size: 13px;
}

@media (max-width: 640px) {
  .sbc-table {
    font-size: 12px;
  }
  .sbc-table input[type="number"] {
    width: 70px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/hr_app/EmpRegistration/Salarybreakupcalculator.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qFAAqF;EACrF,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".sbc-wrapper {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 24px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n  color: #2b2b2b;\n}\n\n.sbc-header h2 {\n  margin: 0 0 4px;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.sbc-subtitle {\n  margin: 0 0 20px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Employee info strip */\n.sbc-employee-grid {\n  display: grid;\n  grid-template-columns: 120px minmax(0, 1fr);\n  column-gap: 12px;\n  row-gap: 6px;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.sbc-employee-grid label {\n  margin: 0;\n  color: #000;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.employee-value {\n  margin: 0;\n  padding: 0;\n  color: #0d6efd;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sbc-employee-grid input:focus {\n  outline: none;\n  border-color: #6366f1;\n  background: #fff;\n}\n\n/* Mode toggle */\n.sbc-mode-toggle {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.sbc-mode-toggle label {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid #d8dce1;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4b5563;\n  transition: all 0.15s ease;\n}\n\n.sbc-mode-toggle label.active {\n  border-color: #6366f1;\n  background: #eef0ff;\n  color: #4338ca;\n}\n\n.sbc-mode-toggle input[type=\"radio\"] {\n  accent-color: #6366f1;\n}\n\n/* Primary input */\n.sbc-primary-input {\n  margin-bottom: 20px;\n}\n\n.sbc-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: #374151;\n}\n\n.sbc-field input {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: 16px;\n  border: 1px solid #c7cbd1;\n  border-radius: 8px;\n}\n\n.sbc-field input:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n/* Table */\n.sbc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  margin-bottom: 16px;\n  border: 1px solid #d8dce1;\n}\n\n.sbc-table th {\n  text-align: left;\n  background: #f3f4f6;\n  padding: 10px 12px;\n  font-weight: 600;\n  border-bottom: 1px solid #d8dce1;\n}\n\n.sbc-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eceef1;\n  vertical-align: middle;\n}\n\n.sbc-table td:nth-child(2),\n.sbc-table td:nth-child(3) {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.sbc-table tbody tr:hover {\n  background: #fafbff;\n}\n\n.sbc-table input[type=\"number\"] {\n  width: 90px;\n  padding: 5px 8px;\n  text-align: right;\n  border: 1px solid #c7cbd1;\n  border-radius: 5px;\n  font-size: 13px;\n}\n\n.sbc-table input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #6366f1;\n}\n\n.sbc-section td {\n  background: #eef0ff;\n  color: #4338ca;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.sbc-subtotal td {\n  background: #f3f4f6;\n  font-weight: 700;\n  border-top: 1px solid #d8dce1;\n  border-bottom: 1px solid #d8dce1;\n}\n\n.sbc-total td {\n  background: #111827;\n  color: #fff;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.sbc-warning-row td {\n  background: #fff4f4;\n}\n\n.sbc-warning-text {\n  color: #b42318;\n  background: #fff4f4;\n  border: 1px solid #fecaca;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n/* Assumptions panel */\n.sbc-toggle-assumptions {\n  background: none;\n  border: none;\n  color: #4338ca;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 12px;\n}\n\n.sbc-toggle-assumptions:hover {\n  text-decoration: underline;\n}\n\n.sbc-assumptions-panel {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  padding: 16px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.sbc-assumption-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sbc-assumption-row label {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.sbc-assumption-row input {\n  padding: 6px 8px;\n  border: 1px solid #c7cbd1;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n@media (max-width: 640px) {\n  .sbc-table {\n    font-size: 12px;\n  }\n  .sbc-table input[type=\"number\"] {\n    width: 70px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
